import { useFlags } from "launchdarkly-react-client-sdk";

export const useBooleanFlag = (name: string, fallback: boolean) => {
    const flags = useFlags() ?? {};
    return flags[name] ?? fallback;
}